import PropTypes from 'prop-types';

export default {
  apiUrl: PropTypes.string.isRequired,
  blobBaseUrl: PropTypes.string.isRequired,
  gmaUrl: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired,
};
